import GalleryCard from "@components/BasicComponents/Cards/GalleryCard/GalleryCard"
import {
	MediaGalleryModuleType,
	MediaType,
} from "@hooks/WorkWithJson/GetComponentDataByKey/GetComponentDataByKeyTypes"
import React from "react"

import styles from "./GalleryImagesBox.module.scss"

type Props = {
	data: MediaGalleryModuleType
}

const GalleryImagesBox = (props: Props) => {
	return (
		<>
			<div className={styles.cardContainer}>
				{props.data.media.map((element: MediaType, index: number) => {
					return (
						<React.Fragment key={index}>
							{element.preview && (
								<GalleryCard
									className={styles.cardBox}
									element={element.preview}
								/>
							)}
						</React.Fragment>
					)
				})}
			</div>
		</>
	)
}

export default GalleryImagesBox
